angular.module('zc.projects')

.directive 'campaignBaseStep', ->
  restrict: 'E'
  scope:
    project: '='
    campaign: '='
    basicForm: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_base_step.html'
  controller: ($scope, Meta, currencies) ->
    $scope.campaignDevices = []
    $scope.currency = currencies[$scope.project.currency]

    if $scope.campaign.fee_rate is null
      $scope.campaign.fee_rate = $scope.project.fee_rate

    Meta.getDevices().then (devices) ->
      $scope.campaignDevices = devices.filter (device) ->
        $scope.project.enable_app || device.name != 'app'

    $scope.$watch 'campaign.campaign_device', (newVal, oldVal) ->
      return if newVal is oldVal
      $scope.campaign.template_type = null
      $scope.campaign.template = null



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_base_step.coffee